export const STEPS = [
  { id: "welcome", title: "Welcome", subtitle: "Begin your journey" },
  { id: "agreement", title: "Enrollment Agreement", subtitle: "Terms & commitments" },
  { id: "documents", title: "Documents", subtitle: "Records upload (secure)" },
  { id: "parent", title: "Parent Info", subtitle: "Guardian details" },
  { id: "student", title: "Student Info", subtitle: "Student details" },
  { id: "medical", title: "Medical", subtitle: "Health & emergency" },
  { id: "liability", title: "Liability", subtitle: "Waiver of risk" },
  { id: "media", title: "Media", subtitle: "Photo & video release" },
  { id: "academic", title: "Academic Release", subtitle: "Records authorization" },
  { id: "expectations", title: "Expectations", subtitle: "Code of conduct" },
  { id: "tech", title: "Tech Integrity", subtitle: "Acceptable use" },
  { id: "uniforms", title: "Uniforms", subtitle: "Sizing & order" },
  { id: "logins", title: "Logins", subtitle: "Portal credentials" },
  { id: "tuition", title: "Tuition", subtitle: "Tier & enrollment fee" },
  { id: "orientation", title: "Orientation", subtitle: "Sign & submit" },
];
